export function getSessionId(productSlug: string): string {
  const key = `cc-chatbot-session-${productSlug}`
  try {
    let id = localStorage.getItem(key)
    if (!id) {
      id = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : fallbackUuid()
      localStorage.setItem(key, id)
    }
    return id
  }
  catch {
    // localStorage can throw in privacy-mode / sandboxed contexts — fall back
    // to an in-memory ID for the lifetime of this page.
    return fallbackUuid()
  }
}

function fallbackUuid(): string {
  // RFC4122 v4 via Math.random — only used when crypto.randomUUID isn't
  // available (very old browsers). Good enough for a chat session id.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
